import { AfterViewInit, Component, DestroyRef, ElementRef, inject, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, switchMap, take } from 'rxjs';
import { NectaUser } from 'src/app/shared/user/models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { NectaSessionService } from '../services/necta-session.service';
import { Session } from '../models/session';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { ConfigService } from 'src/app/shared/services/config-service';
import { IframeCommunicationService } from 'src/app/shared/services/iframe-communication.service';

@Component({
  selector: 'app-necta-frame',
  imports: [],
  templateUrl: './necta-frame.component.html',
  styleUrl: './necta-frame.component.css'
})
export class NectaFrameComponent implements AfterViewInit {
  @ViewChild('embeddedNectaClientFrame', { static: true }) embeddedFrame!: ElementRef<HTMLIFrameElement>;

  private readonly nectaSessionService = inject(NectaSessionService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly loadingService = inject(LoadingService);
  private readonly configurationService = inject(ConfigService);
  private readonly iframeCommunication = inject(IframeCommunicationService);
  private readonly destroyRef = inject(DestroyRef);
  private user: WritableSignal<NectaUser|null> = signal(null);

   ngOnInit() {
     this.iframeCommunication.logout$
       .pipe(takeUntilDestroyed(this.destroyRef))
       .subscribe(() => this.router.navigate(['/dashboard/welcome']));

     // Reload nach Kostenstellenwechsel im GWT-necta: iframe mit den mitgelieferten
     // Parametern (inkl. neuer sessionId) neu laden – ohne neue Session anzulegen.
     this.iframeCommunication.reload$
       .pipe(takeUntilDestroyed(this.destroyRef))
       .subscribe(p => {
         const url = this.buildEmbeddedUrl(p.sessionId, p.clientId, p.userCode);
         console.debug('[necta-frame] reload -> ', url);
         this.embeddedFrame.nativeElement.src = url;
       });

     this.route.data.subscribe(data => {
       this.user.set(data['user']); // kommt vom Resolver
       let session: Session = {
        costCenterId: this.user()!.costCenterId, // Annahme: user() gibt ein NectaUser-Objekt zurück
        languageId: 1,
        sessionId: null,
        userId: this.user()!.nectaUserId,
      };
      this.loadingService.show();
      this.nectaSessionService.createNectaSession(session).pipe( // Lade-Indikator ausschalten, sobald Stream endet oder Fehler kommt
              finalize(() => this.loadingService.hide()))
              .subscribe((sessionResult: Session) => {
         // Setzen Sie die URL des iFrames.
         this.embeddedFrame.nativeElement.src = this.buildEmbeddedUrl(
           sessionResult.sessionId!, this.user()!.tenantId, this.user()!.nectaUserCode);
      });
     });
    }

  /**
   * Baut die iFrame-URL für den Embedded Necta-Client.
   * embedded=true + parentOrigin signalisieren dem GWT-Client, dass er beim Logout statt einer
   * Top-Navigation eine postMessage an den Parent senden soll (verhindert SecurityError im iframe).
   * clientId entspricht der tenantId (relevant für die Tenant-Subdomain in getUrlNectaClient).
   */
  private buildEmbeddedUrl(sessionId: string, clientId: string | number, userCode: string): string {
    const nectaUrl = this.configurationService.getUrlNectaClient(clientId);
    const parentOrigin = window.location.origin;
    return `${nectaUrl}?sessionId=${encodeURIComponent(sessionId)}`
      + `&clientId=${encodeURIComponent(String(clientId))}`
      + `&userCode=${encodeURIComponent(userCode)}`
      + `&embedded=true&parentOrigin=${encodeURIComponent(parentOrigin)}`;
  }

  ngAfterViewInit() {

  }
}


